var map = {
	"./icon_dianpu_ALI_1688.png": "./src/assets/images/ecommercepng/icon_dianpu_ALI_1688.png",
	"./icon_dianpu_BEIBEI.png": "./src/assets/images/ecommercepng/icon_dianpu_BEIBEI.png",
	"./icon_dianpu_BLBL.png": "./src/assets/images/ecommercepng/icon_dianpu_BLBL.png",
	"./icon_dianpu_DEWU.png": "./src/assets/images/ecommercepng/icon_dianpu_DEWU.png",
	"./icon_dianpu_DYDF.png": "./src/assets/images/ecommercepng/icon_dianpu_DYDF.png",
	"./icon_dianpu_GOME.png": "./src/assets/images/ecommercepng/icon_dianpu_GOME.png",
	"./icon_dianpu_JD.png": "./src/assets/images/ecommercepng/icon_dianpu_JD.png",
	"./icon_dianpu_JP.png": "./src/assets/images/ecommercepng/icon_dianpu_JP.png",
	"./icon_dianpu_KS.png": "./src/assets/images/ecommercepng/icon_dianpu_KS.png",
	"./icon_dianpu_LUBAN.png": "./src/assets/images/ecommercepng/icon_dianpu_LUBAN.png",
	"./icon_dianpu_MGJ.png": "./src/assets/images/ecommercepng/icon_dianpu_MGJ.png",
	"./icon_dianpu_PDD.png": "./src/assets/images/ecommercepng/icon_dianpu_PDD.png",
	"./icon_dianpu_PDDDF.png": "./src/assets/images/ecommercepng/icon_dianpu_PDDDF.png",
	"./icon_dianpu_PDDKJ.png": "./src/assets/images/ecommercepng/icon_dianpu_PDDKJ.png",
	"./icon_dianpu_SN.png": "./src/assets/images/ecommercepng/icon_dianpu_SN.png",
	"./icon_dianpu_TAOBAO.png": "./src/assets/images/ecommercepng/icon_dianpu_TAOBAO.png",
	"./icon_dianpu_WD.png": "./src/assets/images/ecommercepng/icon_dianpu_WD.png",
	"./icon_dianpu_WXGYS.png": "./src/assets/images/ecommercepng/icon_dianpu_WXGYS.png",
	"./icon_dianpu_WXSPH.png": "./src/assets/images/ecommercepng/icon_dianpu_WXSPH.png",
	"./icon_dianpu_XIAOHS.png": "./src/assets/images/ecommercepng/icon_dianpu_XIAOHS.png",
	"./icon_dianpu_YZ.png": "./src/assets/images/ecommercepng/icon_dianpu_YZ.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/ecommercepng sync recursive ^\\.\\/icon_dianpu_.*\\.png$";